import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=1cd94a87&scoped=true&"
import script from "./WorkDetails.vue?vue&type=script&lang=js&"
export * from "./WorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetails.vue?vue&type=style&index=0&id=1cd94a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd94a87",
  null
  
)

export default component.exports